/* eslint-disable */
import React, { useContext } from 'react';
import { Button } from '@material-ui/core';
import { useMutation, useQueryClient } from 'react-query';
import { LabFilesCtx } from 'pages/LabFilesPage';
import AppTable from '../../basic/AppTable';
import { useAlerts } from '../../../hooks/alerts-hooks';
import { useQueryParams } from '../../../hooks/atoms/query-params-hook';
import CollectionKeys from '../../../hooks/molecules/collection-keys';
import axiosClient from '../../../http/axios-client';
import { v4 as uuidv4 } from 'uuid';

const LabCSVUploadPreview = (props) => {
  const { dataCSV, setDataCSV } = useContext(LabFilesCtx);
  const { alertSuccess, alertError } = useAlerts();

  const paginationWithoutCount = useQueryParams();

  const queryClient = useQueryClient();

  const {
    mutateAsync: uploadLabFile,
    isLoading: LabFileUploading,
  } = useMutation(
    [ CollectionKeys.LAB_FILES, 'UPLOAD' ],
    (payload) => {
      return axiosClient.post(`${ CollectionKeys.LAB_FILES }`, payload);
    },
    {
      onSettled() {
        return queryClient.invalidateQueries([ `${ CollectionKeys.LAB_FILES }` ]);
      },
    },
  );

  if (!dataCSV) {
    return <h5>No data to preview</h5>;
  }

  const { rows, columns, fileName } = dataCSV;

// create data for preview table
  const data = rows.map((r) => {
    return r.reduce((acc, attr) => {
      acc[attr.Key] = attr.Value;
      return acc;
    }, {});
  });
  
  const handleUpload = () => {
    const metadata = rows.map((item) => {

      const data = item.reduce((acc, attr) => {
        // add id
    const uid = uuidv4();
        acc['uid'] = uid;

        switch (attr.Key) {
          case 'Date':
            let date = new Date(attr.Value)
            if(!isNaN(date)){
              acc['date'] = date.toISOString();
            } else {
              acc['date'] = '-';
            }

          case 'Sample Name':
            acc['sample_name'] = attr.Value;
            break;
          case 'Nucleic Acid(ng/uL)':
            acc['nucleic_acid'] = attr.Value;
            break;
          case 'A260/A280':
              acc['a260_a280'] = attr.Value;
              break;
          case 'A260/A230':
                acc['a260_a230'] = attr.Value;
                break;
          case 'A260':
                acc['a260'] = attr.Value;
                break;
          case 'A280':
                acc['a280'] = attr.Value;
                break;
          case 'Nucleic Acid Factor':
            acc['nucleic_acid_factor'] = attr.Value;
            break;
          case 'Baseline Correction (nm)':
            acc['baseline_correction'] = attr.Value;
            break;
          case 'Baseline Absorbance':
            acc['baseline_absorbance'] = attr.Value;
            break;
        }
        
        return acc;
      }, {});
      return data;
    })

    const dataToUpload = {
      file_name : fileName,
      status: 'Not_Imported',
      metadata : metadata
    }


    let wrongSerial = dataToUpload.metadata.find((s) => {
      if (s?.sample_name === undefined) { return false; }
      return !/^[A-Z]{2}\d{6}$/.test(s.sample_name);
    });

    let wrongDate = dataToUpload.metadata.find((s) => {
      if (s?.date === undefined || s.date === '') { return false; }
      return  !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(s.date);
    });

    let wrongNcAcid = dataToUpload.metadata.find((s) => {
      if (s?.nucleic_acid === undefined) { return false; }
      return  Number.isFinite(s.nucleic_acid) && /^\d+\.\d+$/.test(s.nucleic_acid);
    });

    if (wrongSerial) {
      alertError(`Serial number ${ wrongSerial.sample_name } doesn't have the correct format with category prefix followed by 6 digits or missing.`);
      return undefined;
    }

    if (wrongDate) {
      alertError(`Date ${wrongDate.date} in ${ wrongDate.sample_name } doesn't have the correct format or missing.`);
      return undefined;
    }

    if (wrongNcAcid) {
      alertError(`Nucleic Acid in ${ wrongDate.sample_name } doesn't have the correct format or missing.`);
      return undefined;
    }



  props.setLoading(true);

    return uploadLabFile(dataToUpload)
      .then(() => {
        alertSuccess('Lab File uploaded');
        setDataCSV(null);
      })
      .catch((err) => {
        alertError(JSON.stringify(err));
      }).finally(() => {
        props.setLoading(false);
      });
  };

  return (
    <>
      <AppTable
        columns={ columns }
        data={ data?.slice(paginationWithoutCount.page * paginationWithoutCount.limit, (paginationWithoutCount.page + 1) * paginationWithoutCount.limit) }
        paginationProps={ { ...paginationWithoutCount, count: data?.length } }
      />
      <Button
        style={ { background: '#93C120', color: 'white' } }
        disabled={ LabFileUploading }
        onClick={ handleUpload }
      >
        Upload Lab CSV File
      </Button>
    </>
  );
};

export default LabCSVUploadPreview;
